import React from "react";

/**
 * PMB Loans brand logo. Renders the SVG shipped in /public/pmbloans_logo.svg.
 * The SVG is 400x100 (4:1 ratio), so we only set height and let width auto.
 */
export default function Logo({ className = "", height = 28, alt = "PMB Loans" }) {
  return (
    <img
      src="/pmbloans_logo.svg"
      alt={alt}
      height={height}
      style={{ height, width: "auto" }}
      className={`select-none ${className}`}
      data-testid="pmb-logo"
      draggable={false}
    />
  );
}
